import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Auth } from 'aws-amplify';
import { UserQuery } from '../services/user/user.query';
import {requestsService} from '../services/requests/requests.service'
//import {ApiClientClass} from 'purecloud-platform-client-v2';
import { Config } from '../config';
import {GenesystokenService} from '../services/genesystoken.service'
import {ReportsdetailsService} from '../services/reportsdetails.service';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../services/auth.service';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  showError: string = null;
  showSuccess = false;
    loginUrl:any;
  hide : boolean = true;
  hidePassword:boolean=true
  platformclient:any;
  pcEnvironment:any;
  pcLanguage:any; 
  clientApp:any=null;   
   showMultiAppOTP=false;
    showOTP=false;
     users:any;
     inprogress:boolean=false
  // CAPTCHA temporarily disabled — keep for easy restore
  // captchaText: string = '';
  // captchaInput: string = '';
  // captchaError: boolean = false;
  private readonly adminPanelRoute = '/home/admin-pannel/select-query-run';
  constructor(private router: Router,
    private user: UserQuery,private apiService: requestsService,private config:Config,private genesysServie:GenesystokenService,private propService:ReportsdetailsService,private toastr: ToastrService,
    private authService: AuthService) {
      this.platformclient= (<any>window).platformClient;
   
  
    this.loginForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
      password: new FormControl('', [Validators.required]),
      remember: new FormControl(false),
       code:new FormControl(),
      ScanerCode:new FormControl(),
            route: new FormControl(),
    })
    // CAPTCHA temporarily disabled.
  }

  // CAPTCHA temporarily disabled — keep for easy restore
  // generateCaptcha() {
  //   const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789';
  //   let result = '';
  //   for (let i = 0; i < 6; i++) {
  //     result += chars.charAt(Math.floor(Math.random() * chars.length));
  //   }
  //   this.captchaText = result;
  //   this.captchaInput = '';
  //   this.captchaError = false;
  // }

  // validateCaptcha(): boolean {
  //   if (this.captchaInput !== this.captchaText) {
  //     this.captchaError = true;
  //     this.generateCaptcha();
  //     return false;
  //   }
  //   this.captchaError = false;
  //   return true;
  // }

  ngOnInit(): void {
    const token = this.user.getToken();
    this.loginForm.controls.route.setValue('');
    if (token) {
      if (this.authService.isTokenExpired(token)) {
        // Stale cookie present — clear it silently so the auth guard
        // is never reached and no "Session Expired" toast fires
        // on a normal Sign In page load.
        this.authService.resetAppData();
      } else {
        this.router.navigateByUrl('/home');
      }
    }
    if(this.genesysServie.tokenType ==="genesys")
    {
      if(this.genesysServie._alreadyLogged == false){
        this.setDynamicParameters();
        // Setup Client App
        
        const client= this.platformclient.ApiClient.instance;
        client.setEnvironment(this.pcEnvironment.replace(".login","").replace("/oauth",""));
        client.setPersistSettings(true,this.config.appName)
        const urlParams = new URLSearchParams(window.location.search);
        // client.loginCodeAuthorizationGrant(this.config.clientID,this.config.clientSecret,"OAuth",this.config.premiumAppURL).then(res=>{
        //   console.log(res)
        // })
        client.loginImplicitGrant(this.config.clientID,this.config.wizardUriBase).then(res=>{
          this.genesysServie._alreadyLogged=true;
          this.genesysServie.dataToken = res.accessToken;
          this.router.navigateByUrl('/home');
          this.apiService.AWSUserDetails().subscribe(s=>{
            if(this.propService.EmailLink !=null){
              window.location.href=this.propService.EmailLink
              //this.router.navigateByUrl(this.propService.EmailLink)
            }
            else{
              this.router.navigateByUrl('/home');
             this.myBrowser()
          }});
    
        }).catch((e) => {
          alert('access_token')
          alert(e)
    
        }); 
      }
    
    }
    
  }

  setRemember(val) {
    this.loginForm.controls.remember.patchValue(val);
  }
  onEnterKeyDown() {
    this.signIn()
  }

  signIn() {
    if (this.loginForm.invalid) {
      this.loginForm.controls.email.markAsTouched();
      this.loginForm.controls.password.markAsTouched();
      return;
    }
    // CAPTCHA temporarily disabled
    // if (!this.validateCaptcha()) {
    //   return;
    // }
    const params = this.loginForm.value;
    this.showError = null;

    Auth.signIn(params.email, params.password).then((res: any) => {
        this.users=res
      var challengeName=res.preferredMFA;
      if (res.signInUserSession && res.signInUserSession.idToken) {
        this.showSuccess = true;
        this.user.setToken(res.signInUserSession.idToken.jwtToken);
        localStorage.setItem('UserCred', JSON.stringify({ Username: params.email, Password: params.password }));
        this.apiService.AWSUserDetails().subscribe(s=>{
            //  this.apiService.getOrgAuthenticatorAppMFA().subscribe(res1=>{
            //     if(res1==true){
            //       console.log("login MFA")
            //       this.navigateToLandingPage('/home/profile-section');
            //     }else{
            //       console.log("login MFAS")
            //       this.navigateToLandingPage('/home'+this.loginForm.controls.route.value);
            //     }
            //   })
        });
        this.user.setUserName(params.email);
        this.user.setPassword(params.password);
        this.myBrowser();
      }else if(res.challengeName=='SMS_MFA'){
        this.showOTP=true
        this.toastr.success("OTP send successfully")
      }else if(res.challengeName=='SOFTWARE_TOKEN_MFA'){
        this.showMultiAppOTP=true
        this.toastr.success("OTP send successfully")
      }  else {
        this.showError = 'Something went wrong. Try again';
      }
    }, err => {
      this.showError = err.message;
    });
  }
togglePasswordVisibility() {
  this.hidePassword = !this.hidePassword;
}
  setDynamicParameters(){
   // Get Query Parameters
    const urlParams = new URLSearchParams(window.location.search);
    let tempLanguage = urlParams.get(this.config.languageQueryParam);
    let tempPcEnv = urlParams.get(this.config.genesysCloudEnvironmentQueryParam); 
  
    // Language
    this.pcLanguage = tempLanguage || this.genesysServie.getLanguage ||
                this.config.defaultLanguage;
  
   
    this.genesysServie.setLanguage =this.pcLanguage
    // Environment
    
    this.pcEnvironment = tempPcEnv ||
                    this.genesysServie.getAppName
                     ||
                    this.config.defaultPcEnvironment;

    this.genesysServie.setAppName= this.pcEnvironment;   
  }
  myBrowser() { 
    if( window.navigator.userAgent.indexOf("edge") != -1 ) {
      this.toastr.success("For better Result please use Google Chrome")
        return 'edge';
    }else if(window.navigator.userAgent.indexOf("Firefox") != -1 ){
      this.toastr.success("For better Result please use Google Chrome")
      return 'Firefox'; 
    }else if(navigator.userAgent.indexOf("Chrome") != -1 ){
        return 'Chrome';
    }else if(window.navigator.userAgent.indexOf("Safari") != -1){
      this.toastr.success("For better Result please use Google Chrome")
        return 'Safari';
    }else if(window.navigator.userAgent.indexOf("AppleWebKit") != -1 ) {
      this.toastr.success("For better Result please use Google Chrome")
         return 'AppleWebKit';
    }else if(window.navigator.userAgent.indexOf("edg") != -1 ) {
      this.toastr.success("For better Result please use Google Chrome")
         return 'edge';
    }
    else {
      this.toastr.success("For better Result please use Google Chrome")
       return 'unknown';

    }

}
loginWithCOID(){
  this.loginUrl="https://eu-west-2yslfrruwu.auth.eu-west-2.amazoncognito.com/login?client_id=a02ah9q9lhtl39n8u63i28vtf&response_type=token&scope=email+openid+profile&redirect_uri=https%3A%2F%2Fonecg-prod-samlintgrtion.d3bijszcmlj4kq.amplifyapp.com%2F";
    window.location.assign(this.loginUrl)
}
  onEnterKeyDownOtp() {
    this.codeVeryfy()
  }
  onEnterKeyMUltipDownOtp(){
    this.codeMultifactorVeryfy()
  }
  codeMultifactorVeryfy(){
      this.inprogress=true      
    const params = this.loginForm.value;
    Auth.confirmSignIn(this.users, this.loginForm.controls.ScanerCode.value,'SOFTWARE_TOKEN_MFA').then(res =>{
      var lastLoginTime= res.signInUserSession?.idToken.payload.auth_time;
      const authTimeInMilliseconds = lastLoginTime * 1000;

      const date = new Date(authTimeInMilliseconds);
      const formattedDateTime = date.toLocaleString();
      if (res.signInUserSession && res.signInUserSession.idToken) {
        this.showSuccess = true;
        this.user.setToken(res.signInUserSession.idToken.jwtToken);
        localStorage.setItem('UserCred', JSON.stringify({ Username: params.email, Password: params.password }));
          // Auth.currentAuthenticatedUser().then(user => {console.log("after",user)})
        this.apiService.AWSUserDetails().subscribe(s=>{
           this.inprogress=false 
          this.navigateToLandingPage('/home'+this.loginForm.controls.route.value);
        });
        this.apiService.getRoleListByUsername().subscribe(res=>{
          this.user.setRole(res)
        })
        this.myBrowser();
      }
    }, err => {
         this.inprogress=false 
     this.toastr.error("Please enter valid OTP code")
    })
  }
    codeVeryfy(){
      this.inprogress=true
    const params = this.loginForm.value;
    Auth.confirmSignIn(this.users, this.loginForm.controls.code.value,'SMS_MFA').then(res =>{
      var lastLoginTime= res.signInUserSession?.idToken.payload.auth_time;
      const authTimeInMilliseconds = lastLoginTime * 1000;

      const date = new Date(authTimeInMilliseconds);
      const formattedDateTime = date.toLocaleString();
      if (res.signInUserSession && res.signInUserSession.idToken) {
        this.showSuccess = true;
        this.user.setToken(res.signInUserSession.idToken.jwtToken);
        localStorage.setItem('UserCred', JSON.stringify({ Username: params.email, Password: params.password }));
          // Auth.currentAuthenticatedUser().then(user => {console.log("after",user)})
        this.apiService.AWSUserDetails().subscribe(s=>{
          this.inprogress=false       
          this.navigateToLandingPage('/home'+this.loginForm.controls.route.value);
        });
        this.apiService.getRoleListByUsername().subscribe(res=>{
        this.user.setRole(res)
        })
        // this.user.setUserName(params.email);
        // this.user.setPassword(params.password);
        this.myBrowser();
      }
    }, err => {
        this.inprogress=false       
     this.toastr.error("Please enter valid OTP code")
    })
  }

  private navigateToLandingPage(defaultRoute: string): void {
    this.apiService.isPlatFormAdmin().subscribe((res: any) => {
      if (this.isPlatformAdmin(res)) {
        this.apiService.oneCgBuildVersion().subscribe((buildRes: any) => {
          localStorage.setItem('qtBuildVersion', JSON.stringify(buildRes));
        });
        this.router.navigateByUrl(this.adminPanelRoute);
      } else {
        this.router.navigateByUrl(defaultRoute);
      }
    }, () => {
      this.router.navigateByUrl(defaultRoute);
    });
  }

  private isPlatformAdmin(res: any): boolean {
    if (typeof res === 'boolean') {
      return res;
    }
    if (res && typeof res === 'object') {
      return !!(res.isPlatFormAdmin || res.isPlatformAdmin || res.data);
    }
    return false;
  }
}
